export const PAXEL_STATUS_MAP = {
  RTP: "Courier sedang menuju lokasi pickup",
  COL: "Courier sudah sampai di titik jemput paket",
  PRJL: "Pickup dibatalkan oleh courier",
  RAP: "Percobaan pickup ulang",
  PAPV: "Yay! Paketmu telah diterima oleh Courier",
  POL: "Courier akan mengantar paketmu!",
  ODL: "Courier telah tiba di locker tujuan",
  POD: "Hore! Courier sedang otw antar paket ke tujuanmu!",
  COD: "Courier telah tiba di tujuan",
  PDO: "Paketmu telah berhasil diantar oleh Courier",
  UNDLM: "Pengiriman gagal",
  HAPH: "Ditahan di Paxel Home",
  RTN: "Paket dikembalikan",
  CCS: "Pengiriman di cancel",
  CONFIRMED: "Terima kasih untuk ordernya! Order sudah diterima dan paket akan segera diproses!"
}